module.exports = __webpack_public_path__ + "front/img/avatar_default.d92c2838.png";